<template>
  <div id="app" style="position: absolute; height: 100%; width: 100%; min-width: 1200px;">
    <dashboard></dashboard>
  </div>
</template>

<script>
import dashboard from './components/dashboard'

export default {
  name: 'app',
  components: {
    dashboard
  },
  data() {
    return {
      seller: {}
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// App.vue?48f44baf